import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css'; 

const cardData = [
  { title: "System Hacking", image: "https://skillsuprise.com/data/cyberPDF/topics/system hacking.png" },
  { title: "Mobile Hacking", image: "https://skillsuprise.com/data/cyberPDF/topics/mobile hacking.png" },
  { title: "Website Hacking", image: "https://skillsuprise.com/data/cyberPDF/topics/website hacking.png" },
  { title: "Bug Bounty", image: "https://skillsuprise.com/data/cyberPDF/topics/Bug Bounty.png" },
  { title: "Password Cracking", image: "https://skillsuprise.com/data/cyberPDF/topics/password carcking.png" },
  { title: "Wi-Fi Hacking", image: "https://skillsuprise.com/data/cyberPDF/topics/Wifi hacking.png" },
  { title: "Bug Hunting", image: "https://skillsuprise.com/data/cyberPDF/topics/Bug hunting.png" },
  { title: "Flipper Zero", image: "https://skillsuprise.com/data/cyberPDF/topics/Flipper Zero.png" },
  { title: "IoT Hacking", image: "https://skillsuprise.com/data/cyberPDF/topics/IoT.png" },
  { title: "Virus Making", image: "https://skillsuprise.com/data/cyberPDF/topics/Virus Making.png" },
  { title: "Hacking with AI", image: "https://skillsuprise.com/data/cyberPDF/topics/Hacking WithAI.png" },
  { title: "HackRF", image: "https://skillsuprise.com/data/cyberPDF/topics/hack RF.png" },
  { title: "Server Hacking", image: "https://skillsuprise.com/data/cyberPDF/topics/server.png" },
  { title: "WhatsApp Hacking", image: "https://skillsuprise.com/data/cyberPDF/topics/whatsapp.png" },
  { title: "Sim Card Cloning", image: "https://skillsuprise.com/data/cyberPDF/topics/sim card.png" },
  { title: "Drone Hacking", image: "https://skillsuprise.com/data/cyberPDF/topics/drone.png" },
];



const buttonCSS = `
.btn-tech-more {
  /* Color and Text */
  background-color: #0b5ed7; /* A deep, vibrant blue */
  color: #fff;
  font-family: 'Poppins', 'Open Sans', sans-serif; 
  font-size: 1.2rem;
  font-weight: 600; /* Bold */
  
  /* The Key Effect: Text Shadow */
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.6);

  /* Shape and Size */
  border: none;
  border-radius: 50px; /* This creates the "pill" shape */
  padding: 0.75rem 2.5rem; /* Large padding */
  
  /* Other */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.btn-tech-more:hover {
  background-color: #0a58ca; /* Slightly darker on hover */
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* Responsive Font Size */
@media (max-width: 767.98px) {
  .btn-tech-more {
    font-size: 0.7rem;
    padding: 0.6rem 1.5rem;
  }
}
`;

const internalCSS = `
  /* --- Root variables for branding --- */
  :root {
    --card-blue-border: #5A89FF; 
    --text-dark: #333;
    --grid-background: #f8f9fa; 
    --title-blue: #0d6efd; /* Bootstrap blue */
    --title-red: #dc3545; /* Bootstrap red */
  }

  /* --- Top Banner Image --- */
  .kali-linux-banner {
    width: 100%;
    max-height: 450px; 
    object-fit: cover;
    object-position: top center;
    background-color: #000; /* Placeholder bg */
  }

  /* --- Header Title Section --- */
  .master-title-section {
   
    text-align: center;
    background-color: #fff;
  }

  .master-title-main {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--title-blue);
    margin-bottom: 0.25rem;
  }

  .master-title-sub {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 2.2rem;
    font-weight: 700;
    color: var(--title-red);
  }

  .master-title-divider {
   border:'1 px dashed ;
  }
  
  /* --- Cards Grid Section --- */
  .cards-grid-section {
    background-color: var(--grid-background);
   
  }

  /* --- Card Styling (Inch-by-Inch) --- */
  .hack-card {
   
    border-radius: 16px; 
    height: 100%;
    
    border: none;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .hack-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.08);
  }

  /* --- Image Container with Blue Border --- */
  .card-img-wrapper {
    width: 100%; 
    aspect-ratio: 16 / 10; 
    border: 2px solid var(--card-blue-border);
    border-radius: 12px; 
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
   
    background-color: #eee;
  }

  .card-img-top {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* --- Card Body & Title --- */
  .card-body {
    padding: 0;
    min-height: 1.5rem; 
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%; 
  }

  .card-title {
    font-family: 'Poppins', 'Open Sans', sans-serif; 
    font-size: 1rem; 
    font-weight: 600;
    color: var(--text-dark);
    line-height: 1.3;
    margin-bottom: 0;
    white-space: normal;
    width: 100%;
  }

  /* --- ########## RESPONSIVE OVERRIDES ########## --- */

  /* This media query handles your "4 columns on mobile" request.
     It shrinks ALL content to make it fit.
  */
  @media (max-width: 767.98px) {
    .master-title-main {
      font-size: 1.2rem;
    }
    .master-title-sub {
      font-size: 1.5rem;
    }
    
    .cards-grid-section {
    
    }

    .hack-card {
     
      border-radius: 12px;
    }

    .card-img-wrapper {
      border-radius: 8px;
      
    }

    .card-title {
      /* Font shrunk to fit */
      font-size: 0.5rem; 
      line-height: 1.2;
    }
  }

  /* Readjust for tablet */
  @media (min-width: 768px) and (max-width: 991.98px) {
    /* These styles apply to 4-cols on tablet */
    .card-title {
      font-size: 0.5rem;
    }
    .hack-card {
      padding: 1rem;
    }
  }

  /* Desktop styles (restores the original look) */
  @media (min-width: 992px) {
    .card-title {
      font-size: 1rem;
    }
     .hack-card {
     
    }
  }
`;

const MasterHackersPage = () => {
  return (
    <>
      <style>{internalCSS}</style>
      
      {/* --- 1. Top Banner Image --- */}
      <div>
        <img 
          src="https://skillsuprise.com/data/cyberPDF/kali.png" 
          alt="Kali Linux Banner" 
          className="kali-linux-banner"
        />
      </div>

      {/* --- 2. Header Title Section --- */}
      <div className="master-title-section">
        <h2 className="master-title-main">Master Hackers Machine</h2>
        <h3 className="master-title-sub">Kali-Linux - Practically</h3>
        <hr className="master-title-divider" />
      </div>

      {/* --- 3. Cards Grid Section --- */}
      <div className="cards-grid-section">
        <div className="container">
          {/* --- THIS IS THE CHANGE ---
            - row-cols-4: 4 columns on ALL screen sizes (mobile, tablet, desktop)
          */}
         <div className="row row-cols-4 g-2">
            {cardData.map((card, index) => (
              <div className="col" key={index}>
                <div className="card hack-card">
                  {/* Wrapper for image to apply blue border */}
                  <div className="card-img-wrapper">
                    <img 
                      src={card.image} 
                      className="card-img-top" 
                      alt={card.title} 
                    />
                  </div>
                  <div className="card-body">
                    <span style={{fontSize:"7px"}} className="card-title">{card.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
       <style>{buttonCSS}</style>
      <div className="text-center p-4">
        <button className="btn-tech-more">
          +100 More Real-World Hacking Techniques
        </button>
      </div>
      </div>
    </>
  );
};

export default MasterHackersPage;





